import React, { useState, useEffect, lazy, Suspense } from 'react'
import PostLogin from '../../layout/postLogin'
import AuthService from '../../services/auth.service'
// import { Loader } from '../../components'
// import Filter from './components/filter'
// import Grid from './components/grid'
import { useGlobalStore } from '../../store'
// import { SocialMonitorEdit } from '../../pages'
import { useSearchParams } from 'react-router-dom'
import { consoleLog, getObjectAsArray } from '../../util'
import { Wrapper, SocialMonitorEditWrapper, HiddenLoader } from './style'
import { LoaderDots, LoaderDotsWithOverlay } from '../../components'
import { NAME_SOCIAL_MONITOR } from '../../constants'

const Filter = lazy(() => import('./components/filter'))
const Grid = lazy(() => import('./components/grid'))
const SocialMonitorEdit = lazy(() => import('../../pages/socialMonitorEdit'))

const initialFilterDataObject = {
  organizationId: null,
  tab: { TabId: '00000000-0000-0000-0000-000000000001', Label: 'All', IsKeywordFiltered: false },
  selectedTab: 0,
  startIndex: 1,
  // startIndex: (60 * (page - 1)) + 1,
  // count: 60,
  getUnread: false,
  forAdminTerminal: false,
  filterAdminWorkEmail1: null,
  filterAdminWorkEmail2: null,
  filterAdminQuestionNumberField: null,
  filterAdminQuestionField: null,
  filterAdminKeywordField: null,
  filterAdminNotesField: null,
  filterAdminTypeField: null,
  filterAdminSubTypeField: null,
  filterAdminAggregationItemId: null,
  isLastPage: false,
  itemClickedIndex: null,
  id: null
}

const SocialMonitor = () => {
  const [tabData, setTabData] = useState([])
  const [filterData, setFilterData] = useState(initialFilterDataObject)
  const [onLoadFilterData, setOnLoadFilterData] = useState()
  const [gridData, setGridData] = useState()
  const [checkedDataList, setCheckedDataList] = useState([])
  const [loader, setLoader] = useState([])
  const [hiddenLoader, setHiddenLoader] = useState(false)
  const { user, company } = useGlobalStore()
  // const [searchParams] = useSearchParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const sticky = true

  const loadTabData = (filterData) => {
    setLoader(true)
    AuthService.getOrganizationAggregationTabsApi({ organizationId: company?.OrganizationId || null })
      .then((resp) => {
        setTabData(resp?.tabDetails)
        setTimeout(() => {
          const filterDataObject = {
            ...filterData,
            ...getQueryString(),
            organizationId: company?.OrganizationId,
            tab: resp?.tabDetails?.find(f => f.IsKeywordFiltered) || resp?.tabDetails?.find(f => f.Label === searchParams?.get('selectedTab')) || { TabId: '00000000-0000-0000-0000-000000000001', Label: 'All', IsKeywordFiltered: false, selected: true }
          }
          filterDataObject.selectedTab = filterDataObject.tab.Label

          setFilterData(filterDataObject)
          setOnLoadFilterData(getQueryString(resp?.tabDetails))
        }, 1000)
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      }).finally(() => {
        setLoader(false)
      })
  }

  const loadGridData = ({ type = '', aggregationItemId, count = 0 }) => {
    if (type === '' && filterData?.organizationId) {
      const removeNullData = () => {
        const data = {}
        const keys = Object.keys(filterData)
        for (let i = 0; i < keys.length; i++) {
          if (filterData[keys[i]] !== null) {
            data[keys[i]] = filterData[keys[i]]
          }
        }
        delete data.selectedTab
        delete data.itemClickedIndex
        return { ...data, count: 60 }
      }
      setLoader(true)
      setHiddenLoader(true)
      AuthService.getAggregationItemsForOrganizationApi(removeNullData(filterData), count)
        .then((resp) => {
          let data = getObjectAsArray(resp)
          if (data.length === 1 && Object.keys(data[0]).length === 0) {
            data = []
          }
          setGridData(data)
        })
        .catch((error) => {
          consoleLog('ERROR : ', error, count)
        })
        .finally(() => {
          setLoader(false)
          setHiddenLoader(false)
        })
    } else if (['hotList', 'bookmark'].includes(type)) {
      const tempData = gridData.map(d => {
        if (d.AggregationItem.AggregationItemId === aggregationItemId) {
          if (type === 'hotList') { d.IsHotlist = !d.IsHotlist }
          if (type === 'bookmark') { d.IsBookmark = !d.IsBookmark }
        }
        return d
      })
      setGridData(tempData)
    }
  }

  const checkedData = (data) => {
    setCheckedDataList(data)
  }

  const onApply = (action) => {
    if (action === null || checkedDataList.length === 0) return false

    const payload = {
      organizationId: company?.OrganizationId || null,
      aggregationItemIds: checkedDataList.map(d => ({ guid: d })),
      action,
      actionPerformedBy: user?.EmailAddress || user?.user?.EmailAddress
    }

    setLoader(true)
    AuthService.setPerformActionOnAggregationItemsForOrganizationApi(payload)
      .then((resp) => {
        loadGridData({})
        setCheckedDataList([])
      })
      .catch((error) => {
        consoleLog('ERROR : ', error)
      }).finally(() => {
        setLoader(false)
      })
  }

  const itemClickedFunc = (obj, type = 'addId') => {
    loadFilterData(obj, type)
  }

  const loadFilterData = (filterParamData, type) => {
    let filterDataObject = {}
    if (type === 'page') {
      filterDataObject = { ...filterParamData }
    } else if (type === 'filterClicked') {
      filterDataObject = { ...filterParamData, startIndex: 1 }
      setCheckedDataList([])
    } else if (type === 'refreshPage') {
      filterDataObject = { ...filterParamData }
      setCheckedDataList([])
    } else if (type === 'tabChanged') {
      filterDataObject = { ...filterParamData }
      filterDataObject.selectedTab = filterParamData.tab.Label
      setCheckedDataList([])
    } else if (['addId', 'removeId'].includes(type)) {
      filterDataObject = { ...filterParamData }
      setCheckedDataList([])
    } else {
      let pg = 1
      if (gridData?.[0]?.ItemsOnPageNumber) {
        pg = (60 * gridData?.[0]?.ItemsOnPageNumber)
      }
      filterDataObject = { ...filterParamData, startIndex: pg }
    }

    if (!['addId', 'removeId'].includes(type)) {
      delete filterDataObject.itemClickedIndex
      delete filterData.itemClickedIndex
    }

    setFilterData(prev => ({ ...prev, ...filterDataObject }))
    updateQueryString({ ...filterData, ...filterDataObject })
  }

  const monitorSavedFunc = (data) => {
    // loadGridData({})
  }

  const monitorClosedFunc = (id, userDetails) => {
    const obj = filterData
    obj.itemClickedId = null
    if (!gridData) itemClickedFunc(obj, 'removeId')
    if (document?.getElementById('itemClicked')) {
      document.getElementById('itemClicked').focus()
    }
    setTimeout(() => {
      if (document?.getElementById('itemClicked')) {
        document.getElementById('itemClicked').focus()
      }
    }, 1000)
  }

  const objectToQueryString = (obj) => {
    const keys = Object.keys(obj)
    const keyValuePairs = keys.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
    return keyValuePairs.join('&')
  }

  const updateQueryString = (data) => {
    const queryStringObject = {}
    if (data?.selectedTab) { queryStringObject.selectedTab = data.selectedTab }
    if (data?.itemClickedId) { queryStringObject.id = data.itemClickedId }
    if (data?.startIndex) { queryStringObject.startIndex = data.startIndex }
    if (data?.getUnread) { queryStringObject.getUnread = data.getUnread }
    if (data?.forAdminTerminal) { queryStringObject.forAdminTerminal = data.forAdminTerminal }
    if (data?.filterAdminWorkEmail1) { queryStringObject.email1 = data.filterAdminWorkEmail1 }
    if (data?.filterAdminWorkEmail2) { queryStringObject.email2 = data.filterAdminWorkEmail2 }
    if (data?.filterAdminQuestionNumberField) { queryStringObject.questionNumberField = data.filterAdminQuestionNumberField }
    if (data?.filterAdminQuestionField) { queryStringObject.questionField = data.filterAdminQuestionField }
    if (data?.filterAdminKeywordField) { queryStringObject.keywordField = data.filterAdminKeywordField }
    if (data?.filterAdminNotesField) { queryStringObject.notesField = data.filterAdminNotesField }
    if (data?.filterAdminTypeField) { queryStringObject.typeField = data.filterAdminTypeField }
    if (data?.filterAdminSubTypeField) { queryStringObject.subTypeField = data.filterAdminSubTypeField }
    if (data?.filterAdminAggregationItemId) { queryStringObject.aggregationItemId = data.filterAdminAggregationItemId }
    if (data?.isLastPage) { queryStringObject.isLastPage = data.isLastPage }
    if (data?.itemClickedIndex) { queryStringObject.itemClickedIndex = data.itemClickedIndex }

    const params = objectToQueryString(queryStringObject)
    setSearchParams(params)
  }

  const getQueryString = (tabDataParam = []) => {
    const str = searchParams
    const getQueryStringObject = {}
    // if (!str.get('id')) {
    // if (str?.get('id')) { getQueryStringObject.itemClickedId = str.get('id') }
    if (str?.get('startIndex')) { getQueryStringObject.startIndex = str.get('startIndex') }
    if (str?.get('getUnread')) { getQueryStringObject.getUnread = str.get('getUnread') }
    if (str?.get('forAdminTerminal')) { getQueryStringObject.forAdminTerminal = str.get('forAdminTerminal') }
    if (str?.get('email1')) { getQueryStringObject.filterAdminWorkEmail1 = str.get('email1') }
    if (str?.get('email2')) { getQueryStringObject.filterAdminWorkEmail2 = str.get('email2') }
    if (str?.get('questionNumberField')) { getQueryStringObject.filterAdminQuestionNumberField = str.get('questionNumberField') }
    if (str?.get('questionField')) { getQueryStringObject.filterAdminQuestionField = str.get('questionField') }
    if (str?.get('keywordField')) { getQueryStringObject.filterAdminKeywordField = str.get('keywordField') }
    if (str?.get('notesField')) { getQueryStringObject.filterAdminNotesField = str.get('notesField') }
    if (str?.get('typeField')) { getQueryStringObject.filterAdminTypeField = str.get('typeField') }
    if (str?.get('subTypeField')) { getQueryStringObject.filterAdminSubTypeField = str.get('subTypeField') }
    if (str?.get('aggregationItemId')) { getQueryStringObject.filterAdminAggregationItemId = str.get('aggregationItemId') }
    if (str?.get('isLastPage')) { getQueryStringObject.isLastPage = str.get('isLastPage') }
    if (str?.get('itemClickedIndex')) { getQueryStringObject.itemClickedIndex = str.get('itemClickedIndex') }

    if (str?.get('selectedTab') && str?.get('selectedTab') === 'All') {
      getQueryStringObject.selectedTab = str.get('selectedTab')
    }

    // const params = objectToQueryString(queryStringObject)
    // setFilterData({ ...filterData, ...getQueryStringObject })
    // loadGridData()
    return { ...filterData, ...getQueryStringObject }
  }

  useEffect(() => {
    if (user && company?.OrganizationId) loadTabData()
  }, [user, company])

  useEffect(() => {
    if (tabData && filterData && company?.OrganizationId && !searchParams.get('id')) loadGridData({})
  }, [filterData, company])

  useEffect(() => {
    const param = !!searchParams.get('id')
    document.getElementsByTagName('html')[0].style.overflow = param ? 'hidden' : 'visible'
  }, [searchParams.get('id')])

  useEffect(() => {
    document.title = NAME_SOCIAL_MONITOR
  }, [])

  return (
    <PostLogin pageTitle={NAME_SOCIAL_MONITOR}>
      <Wrapper showEdit={!!searchParams.get('id')}>
        <Suspense fallback={<LoaderDots />}>
          <Filter sticky={sticky} filterData={filterData} onLoadFilterData={onLoadFilterData} expanded={true} onChange={loadFilterData} onApply={onApply} />
        </Suspense>
        {tabData?.length > 0 && <Suspense fallback={<LoaderDots />}>
          <Grid sticky={sticky} resetSelectedArray={checkedDataList} tabData={tabData} gridData={gridData} isLoading={loader} onChange={loadFilterData} onItemClicked={itemClickedFunc} getLatestData={loadGridData} onChecked={checkedData} defaultClickedValue={onLoadFilterData?.itemClickedIndex || null} />
        </Suspense>}
      </Wrapper>

      {!!searchParams.get('id') && <Suspense fallback={<LoaderDots />}>
        <SocialMonitorEditWrapper><SocialMonitorEdit pageId={searchParams.get('id')} onSave={monitorSavedFunc} onClose={monitorClosedFunc} /></SocialMonitorEditWrapper>
      </Suspense>}

      {hiddenLoader && <HiddenLoader />}
      {loader && <LoaderDotsWithOverlay />}
    </PostLogin>
  )
}

export default SocialMonitor
